import posthogJS from 'posthog-js';
import * as Log from 'next/dist/build/output/log';

if (!process.env.NEXT_PUBLIC_POSTHOG_HOST || !process.env.NEXT_PUBLIC_POSTHOG_KEY) {
	Log.warnOnce('Posthog logging not configured! See .env.example for more!');
} else {
	posthogJS.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
		api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
		person_profiles: 'never', // We're not interested in info tied to specific users
		persistence: 'sessionStorage', // Use sessionStorage to avoid tracking across sessions
		defaults: '2025-05-24'
	});
}
